<template>
    <div class="fullcontainer teap1" style="background-image:url('res/p1/bg.png');">
      <MusicIcon />
      <img class="bt" src="res/p1/bt.png">
            
      <div class="dt_cont">
        <img class="dt_1 run_scale" src="res/p1/dt-1.png">
        <img class="dt" src="res/p1/ccdt.png">

        <img class="sxjt_1 rotate" src="res/p1/nq.png">
        <img class="sxjt" src="res/p1/dssjt.png?1" @click="$root.$emit('SwitchTo','P4')">
        
        <img class="sxjt_2 rotate" src="res/p1/nq.png">
        <img class="jgc" src="res/p1/ksw.png" @click="GoVrLink(VR_linggangtea)">
        
        <img class="sxjt_3 rotate" src="res/p1/nq.png">
        <img class="yzjd" src="res/p1/cyjgc.png" @click="$root.$emit('SwitchTo','P3')">

        <img class="sxjt_4 rotate" src="res/p1/nq.png">
        <img class="xbt" src="res/p1/xbt.png" @click="GoVrLink(VR_xiaobantang)">
      </div>

      <AnimatePlayer v-if="!silent" animateKey="syyd" @loop="onLoop"/>
      <AnimatePlayer ref="daiji" animateKey="syyddaiji" @init="onInit"/>
    </div> 
</template>

<script>
import MusicIcon from "./MusicIcon";
import AnimatePlayer from "./AnimatePlayer";

import { gotoLink, param, VR_linggangtea, VR_xiaobantang} from "@/d";

let silent = param(window.location.search, "silent", false);

export default {
  data() {
    return {
      silent,
      VR_linggangtea,
      VR_xiaobantang,
    };
  },
  mounted() {
    if (!silent) {
      this.$root.$emit("pausePlayMusic");
    }
  },

  beforeDestroy() {
    silent = this.silent = true;
    this.$root.$emit("continuePlayMusic");
    clearTimeout(this.timeId);
  },

  updated() {},

  methods: {
    onInit(e) {
      if (this.silent) {
        e.play();
      }
    },
    onLoop() {
      this.timeId = setTimeout(() => {
        silent = this.silent = true;
        this.$root.$emit("continuePlayMusic");
        this.$refs.daiji.play();
      }, 800);
    },
    GoVrLink(url = "http://vr.jxsg.net//tour/ede451e921531371") {
      gotoLink(url);
    }
  },
  components: { MusicIcon, AnimatePlayer }
  // extends:canvasAniExt()
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.teap1 {
  @include centerbg; //'res/p1/bg.png'
  .musicpos {
    left: 4%;
  }
  .bt {
    @include horizontalCenterPercent(76%);
    top: 1%;
  }

  .dt_cont {
    position: relative;
    top: 20%;
    .dt_1 {
      @include horizontalCenterPercent(100%);
    }
    .dt {
      top: 0.2rem;
      width: 84%;
      left: 10%;
      top: 4vw;
    }
    .sxjt_1 {
      width: 15%;
      $e: 1.2vw;
      top: calc(-4vw + #{$e});
      left: calc(9vw + #{$e});
    }
    .sxjt {
      width: 40%;
      top: -4vw;
      left: 9vw;
    }
    .sxjt_2 {
      width: 15%;
      $e: 1.2vw;
      top: calc(5vw + #{$e});
      right: calc(10vw + #{$e});
    }
    .jgc {
      width: 44%;
      top: 5vw;
      right: 10vw;
    }

    .sxjt_3 {
      width: 15%;
      $e: 1.2vw;
      top: calc(45vw + 38vw + #{$e});
      left: calc(7vw + #{$e});
    }
    .yzjd {
      width: 19%;
      top: 45vw;
      left: 7vw;
    }

    .sxjt_4 {
      width: 15%;
      $e: 1.2vw;
      top: calc(55vw + 13vw + #{$e});
      right: calc(3vw + #{$e});
    }
    .xbt {
      width: 45%;
      top: 55vw;
      right: 3vw;
    }
  }
}
</style>
